import { render } from "./EvolAmmoChart.vue?vue&type=template&id=074ca918"
import script from "./EvolAmmoChart.vue?vue&type=script&lang=js"
export * from "./EvolAmmoChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__